module.exports = __webpack_public_path__ + "img/Dantam Makeover 17.30f7b33f.jpg";